var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChallengeTraffic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "56px",
    viewBox: "0 0 64 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Company-challenge",
    transform: "translate(-338.000000, -662.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-challenge-traffic",
    transform: "translate(338.000000, 662.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.665,42 L2.81,42 C2.363,42 2,41.637 2,41.19 L2,33.431 C2,30.346 3.718,27.581 6.484,26.215 L12.995,23 L13.452,23 C12.909,22.472 12.41,21.898 11.948,21.287 L5.599,24.423 C2.146,26.127 0,29.58 0,33.431 L0,41.19 C0,42.74 1.26,44 2.81,44 L10.723,44 C10.935,43.293 11.258,42.623 11.665,42 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,2 C23.76,2 27.245,4.985 28.477,8.79 C29.091,8.528 29.743,8.359 30.436,8.301 C28.998,3.606 24.736,0 20,0 C14.166,0 9.048,5.474 9.048,11.714 C9.048,17.734 11.442,22.898 15.452,25.526 C15.914,25.83 16.534,25.701 16.837,25.238 C17.14,24.776 17.011,24.156 16.549,23.853 C13.89,22.11 11.049,18.005 11.049,11.713 C11.048,6.63 15.315,2 20,2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.401,24.422 L51.824,21.174 C51.776,21.306 51.709,21.434 51.618,21.55 C51.241,22.035 50.862,22.519 50.479,23 L51.004,23 L57.515,26.215 C60.282,27.581 62,30.346 62,33.431 L62,41.19 C62,41.636 61.637,42 61.19,42 L52.48,42 C52.785,42.639 53.019,43.296 53.143,44 L61.19,44 C62.74,44 64,42.74 64,41.19 L64,33.431 C64,29.58 61.854,26.127 58.401,24.422 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,0 C39.34,0 35.155,3.499 33.653,8.085 C34.125,8.275 34.584,8.496 35.028,8.756 L35.535,8.756 C36.777,4.967 40.251,2 44,2 C48.685,2 52.952,6.63 52.952,11.714 C52.952,18.376 49.877,22.496 47,24.13 C46.52,24.403 46.352,25.013 46.624,25.493 C46.808,25.818 47.146,26 47.495,26 C47.662,26 47.832,25.958 47.988,25.87 C51.355,23.957 54.953,19.235 54.953,11.715 C54.952,5.474 49.834,0 44,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,56 L13,56 C11.346,56 10,54.654 10,53 L10,44.18 C10,39.987 12.33,36.217 16.081,34.341 L23.553,30.605 L24.448,32.394 L16.976,36.13 C13.906,37.665 12,40.75 12,44.18 L12,53 C12,53.551 12.449,54 13,54 L51,54 C51.551,54 52,53.551 52,53 L52,44.18 C52,40.749 50.094,37.665 47.025,36.13 L39.553,32.394 L40.448,30.605 L47.92,34.341 C51.67,36.217 54,39.987 54,44.18 L54,53 C54,54.654 52.654,56 51,56 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,37 C26.205,37 20,30.169 20,20 C20,13.075 25.607,7 32,7 C38.393,7 44,13.075 44,20 C44,30.169 37.795,37 32,37 Z M32,9 C26.767,9 22,14.243 22,20 C22,29.787 27.808,35 32,35 C36.192,35 42,29.787 42,20 C42,14.243 37.233,9 32,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,52 C16.448,52 16,51.552 16,51 L16,49 C16,48.448 16.448,48 17,48 C17.552,48 18,48.448 18,49 L18,51 C18,51.552 17.552,52 17,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,52 C21.448,52 21,51.552 21,51 L21,49 C21,48.448 21.448,48 22,48 C22.552,48 23,48.448 23,49 L23,51 C23,51.552 22.552,52 22,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,52 C26.448,52 26,51.552 26,51 L26,49 C26,48.448 26.448,48 27,48 C27.552,48 28,48.448 28,49 L28,51 C28,51.552 27.552,52 27,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,52 C31.448,52 31,51.552 31,51 L31,49 C31,48.448 31.448,48 32,48 C32.552,48 33,48.448 33,49 L33,51 C33,51.552 32.552,52 32,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,52 C36.448,52 36,51.552 36,51 L36,49 C36,48.448 36.448,48 37,48 C37.552,48 38,48.448 38,49 L38,51 C38,51.552 37.552,52 37,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,52 C41.448,52 41,51.552 41,51 L41,49 C41,48.448 41.448,48 42,48 C42.552,48 43,48.448 43,49 L43,51 C43,51.552 42.552,52 42,52 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,52 C46.448,52 46,51.552 46,51 L46,49 C46,48.448 46.448,48 47,48 C47.552,48 48,48.448 48,49 L48,51 C48,51.552 47.552,52 47,52 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChallengeTraffic);
export default __webpack_public_path__ + "static/media/icon-challenge-traffic.841de404fdec56f360d99c152f49423c.svg";
export { ForwardRef as ReactComponent };